export default "__VITE_ASSET__N9Nvpg6H__"